import { useEffect, useState } from 'react';
import { Network, ConnectionStatus } from '@capacitor/network';

export const useNetworkStatus = () => {
  const [status, setStatus] = useState<ConnectionStatus>({
    connected: typeof navigator !== 'undefined' ? navigator.onLine : true,
    connectionType: 'unknown',
  });

  useEffect(() => {
    let removeListener: { remove: () => Promise<void> } | undefined;

    const setup = async () => {
      try {
        const initial = await Network.getStatus();
        setStatus(initial);

        removeListener = await Network.addListener('networkStatusChange', (s) => {
          setStatus(s);
        });
      } catch {
        // Browser fallback
        const handleOnline = () => setStatus({ connected: true, connectionType: 'wifi' });
        const handleOffline = () => setStatus({ connected: false, connectionType: 'none' });
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
          window.removeEventListener('online', handleOnline);
          window.removeEventListener('offline', handleOffline);
        };
      }
    };

    setup();

    return () => {
      if (removeListener) removeListener.remove();
    };
  }, []);

  return {
    isOnline: status.connected,
    connectionType: status.connectionType,
  };
};

export default useNetworkStatus;
